import { API_URL } from "../api";
import { getAuthToken } from "../auth";

const fieldLabels = {
  bank_name: 'Банк', bank_bik: 'БИК', bank_account: 'Расчётный счёт', bank_corr_account: 'Корреспондентский счёт',
  contract_number: 'Номер договора', contract_date: 'Дата договора', contract_seller: 'Наша организация по договору',
  company_name: 'Название организации', inn: 'ИНН', kpp: 'КПП', ogrn: 'ОГРН / ОГРНИП',
  legal_address: 'Юридический адрес', postal_address: 'Почтовый адрес', director_name: 'Подписант',
  director_position: 'Должность подписанта', signatory_basis: 'Основание полномочий',
  phone: 'Телефон', email: 'Email', box_id: 'GUID ящика', fns_participant_id: 'Идентификатор участника ЭДО',
  event_id: 'Событие', client_id: 'Заказчик', doc_type: 'Тип документа', seller_id: 'Наша организация',
  file: 'Файл', source_file: 'Файл шаблона', version: 'Версия шаблона',
};
export function documentErrorMessage(value, fallback = 'Не удалось выполнить действие') {
  const flatten = input => {
    if (typeof input === 'string') return input;
    if (Array.isArray(input)) return input.map(flatten).filter(Boolean).join('; ');
    if (input && typeof input === 'object') return Object.entries(input)
      .filter(([key]) => !['code', 'data_version', 'owner_client_id'].includes(key))
      .map(([key, item]) => { const text = flatten(item); return text ? `${fieldLabels[key] ? fieldLabels[key] + ': ' : ''}${text}` : ''; })
      .filter(Boolean).join('; ');
    return '';
  };
  return flatten(value?.message || value?.detail || value) || fallback;
}

export async function documentRequest(
  path,
  { token, method = "GET", data, signal } = {},
) {
  const multipart = data instanceof FormData;
  const response = await fetch(`${API_URL}/documents/${path}`, {
    method,
    signal,
    headers: {
      Authorization: `Bearer ${token || getAuthToken()}`,
      ...(!multipart && data !== undefined
        ? { "Content-Type": "application/json" }
        : {}),
    },
    body:
      data === undefined ? undefined : multipart ? data : JSON.stringify(data),
  });
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const message = documentErrorMessage(body, `Ошибка ${response.status}`);
    const error = new Error(message);
    error.body = body;
    error.status = response.status;
    throw error;
  }
  return body;
}

export async function downloadDocumentFile(id, kind, token) {
  const response = await fetch(`${API_URL}/documents/${id}/file/${kind}/`, {
    headers: { Authorization: `Bearer ${token || getAuthToken()}` },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(documentErrorMessage(body, "Не удалось скачать файл"));
  }
  const url = URL.createObjectURL(await response.blob());
  const a = document.createElement("a");
  a.href = url;
  a.download = responseFilename(response, `document_${id}.${kind === "xml" ? "xml" : "docx"}`);
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function responseFilename(response, fallback) {
  const disposition = response.headers.get('Content-Disposition') || '';
  const encoded = disposition.match(/filename\*=(?:UTF-8|utf-8)''([^;]+)/);
  let value = '';
  try { value = encoded ? decodeURIComponent(encoded[1].trim()) : (disposition.match(/filename="([^"]+)"/)?.[1] || disposition.match(/filename=([^;]+)/)?.[1] || ''); } catch (_) { value = ''; }
  return value.split(/[\\/]/).pop()?.replace(/[\u0000-\u001f\u007f]/g, '').trim() || fallback;
}

export async function documentBinary(path, { token, signal } = {}) {
  const response = await fetch(`${API_URL}/documents/${path}`, {
    signal, headers: { Authorization: `Bearer ${token || getAuthToken()}` },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    const error = new Error(documentErrorMessage(body, 'Не удалось открыть файл'));
    error.status = response.status; error.body = body;
    throw error;
  }
  return { blob: await response.blob(), response };
}

export async function downloadTemplateFile(id, token, { isCurrent = () => true } = {}) {
  const { blob, response } = await documentBinary(`templates/${id}/file/?kind=docx`, { token });
  if (!isCurrent()) return;
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a'); link.href = url;
  link.download = responseFilename(response, `template_${id}.docx`);
  link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
}
